/* Lightweight conditional vendor loader
 * Loads jQuery + OwlCarousel + Fancybox and Splide only on pages that need them.
 * - Looks for selectors: .gridvideo/.owl-carousel/[data-fancybox] and .splide
 * - Injects CSS non-blockingly
 * - Dispatches custom events when libraries are ready: 'Vendor:OwlReady', 'Vendor:SplideReady'
 */
(function(){
  var d = document;
  var head = d.head || d.getElementsByTagName('head')[0];
  var cache = { js: {}, css: {} };

  function onReady(fn){ if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }

  function loadCSS(href){
    if (cache.css[href]) return cache.css[href];
    var l = d.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    head.appendChild(l);
    cache.css[href] = Promise.resolve(l);
    return cache.css[href];
  }

  function loadJS(src){
    if (cache.js[src]) return cache.js[src];
    cache.js[src] = new Promise(function(res, rej){
      var s = d.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function(){ res(s); };
      s.onerror = function(){ rej(new Error('Failed to load ' + src)); };
      (d.body || head).appendChild(s);
    });
    return cache.js[src];
  }

  function when(cond, cb, timeout){
    var start = Date.now();
    (function wait(){
      if (cond()) return cb();
      if (timeout && (Date.now() - start > timeout)) return;
      setTimeout(wait, 40);
    })();
  }

  function initOwlAndFancybox(){
    if (!window.jQuery) return; var $ = window.jQuery;
    try {
      if ($.fn && $.fn.owlCarousel && d.querySelector('.gridvideo')){
        $('.gridvideo').owlCarousel({
          loop: false,
          margin: 30,
          nav: false,
          dots: false,
          responsive: {
            0: { loop: true, items: 1.2, dots: true, autoplay: true, autoplayTimeout: 3000, smartSpeed: 800 },
            600: { loop: true, items: 1.2, dots: true, autoplay: true, autoplayTimeout: 3000, smartSpeed: 800 },
            750: { loop: true, items: 2.2, dots: true, autoplay: true, autoplayTimeout: 3000, smartSpeed: 800 },
            1000: { loop: true, items: 2.2, dots: true, autoplay: true, autoplayTimeout: 3000, smartSpeed: 800 },
            1200: { items: 4 },
            1536: { items: 4 }
          }
        });
      }
      if ($ && $.fancybox){
        $().fancybox({
          selector: '[data-fancybox="videos"], [data-fancybox="images"], [data-fancybox="video"]',
          hash: false,
          thumbs: { autoStart: true },
          buttons: ['zoom','download','close'],
          iframe: { preload: true }
        });
      }
      window.dispatchEvent(new Event('Vendor:OwlReady'));
    } catch(err){ console.warn('Vendor init error', err); }
  }

  function ensureOwlAndFancybox(){
    // Load only if the page uses carousels or fancybox
    var need = d.querySelector('.gridvideo, .owl-carousel, [data-fancybox], [data-fancybox="videos"], [data-fancybox="images"]');
    if (!need) return;

    var load = function(){
      loadCSS('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.carousel.min.css');
      loadCSS('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.theme.default.css');
      loadCSS('https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.2.5/jquery.fancybox.min.css');
      // JS chain: jQuery -> Owl -> Fancybox
      loadJS('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js')
        .then(function(){ return loadJS('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js'); })
        .then(function(){ return loadJS('https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.2.5/jquery.fancybox.min.js'); })
        .then(function(){ initOwlAndFancybox(); })
        .catch(function(err){ console.warn('Vendor load error', err); });
    };

    // If offscreen, delay loading until visible
    if ('IntersectionObserver' in window){
      var observed = false;
      var observer = new IntersectionObserver(function(entries, obs){
        entries.forEach(function(entry){
          if (entry.isIntersecting && !observed){ observed = true; obs.disconnect(); load(); }
        });
      }, { rootMargin: '200px 0px' });
      // Observe the first matching element
      observer.observe(need);
      // Fallback: ensure we still load after idle time
      if ('requestIdleCallback' in window){ requestIdleCallback(function(){ if (!observed) load(); }, { timeout: 4000 }); }
      else { setTimeout(function(){ if (!observed) load(); }, 4000); }
    } else {
      load();
    }
  }

  function initSplideWhenReady(){
    if (window.Splide && window.splide && window.splide.Extensions){
      window.dispatchEvent(new Event('Vendor:SplideReady'));
      return true;
    }
    return false;
  }

  function ensureSplide(){
    var need = d.querySelector('.splide');
    if (!need) return;
    var load = function(){
      loadCSS('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css');
      loadJS('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js')
        .then(function(){ return loadJS('https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-auto-scroll@0.5.3/dist/js/splide-extension-auto-scroll.min.js'); })
        .then(function(){
          window.splide = window.splide || {};
          if (!window.splide.Extensions && window.Splide && window.Splide.Extensions){
            window.splide.Extensions = window.Splide.Extensions;
          }
          initSplideWhenReady();
        })
        .catch(function(err){ console.warn('Splide load error', err); });
    };
    if ('IntersectionObserver' in window){
      var observed = false;
      var observer = new IntersectionObserver(function(entries, obs){
        entries.forEach(function(entry){
          if (entry.isIntersecting && !observed){ observed = true; obs.disconnect(); load(); }
        });
      }, { rootMargin: '200px 0px' });
      observer.observe(need);
      if ('requestIdleCallback' in window){ requestIdleCallback(function(){ if (!observed) load(); }, { timeout: 4000 }); }
      else { setTimeout(function(){ if (!observed) load(); }, 4000); }
    } else {
      load();
    }
  }

  onReady(function(){
    // Stagger to avoid competing with core theme.js
    if ('requestIdleCallback' in window){
      requestIdleCallback(function(){ ensureOwlAndFancybox(); ensureSplide(); }, { timeout: 2000 });
    } else {
      setTimeout(function(){ ensureOwlAndFancybox(); ensureSplide(); }, 0);
    }
  });
})();
